import Vue from '/vodalys/vvuejs/vue'


import { registerAngularModule } from '/vodalys/vparcel/source.init.mjs';

import { camelToKebab } from './utils.mjs'

const componentsMap = new Map()

export let vuejsComponents = {};

export * from './declareVrunComponent.mjs'
export * from './declareVconsoleComponent.mjs'

export function getVueComponent(type) {
    return componentsMap.get(type)
}
export function hasVueComponent(type) {
    return componentsMap.has(type)
}

/**
 * Register a vue component in vue && vodalysform type
 * @param type vodalysform type
 * @param componentName vue component name (html element)
 * @param componentPromise vue component promise (import('componentpath'))
 * @deprecated registerVueComponentLasy is broken, please use registerVueComponent instead
 */
export function registerVueComponentLasy(type, componentName, componentPromise) {
    console.error('registerVueComponentLasy is broken, please use registerVueComponent instead ::', type, componentName)
    registerVueComponent(type, componentName, () => componentPromise)
}

/**
 * Register a vue component in vue && vodalysform type
 * @param type vodalysform type
 * @param componentName vue component name (html element)
 * @param component vue component (import from .vue or vue def object)
 */
export function registerVueComponent(type, componentName, component) {
    componentsMap.set(type, component)
    Vue.component(componentName, component)
}

/**
 * Register a vue component in vue
 * @param componentName vue component name (html element)
 * @param component vue component (import from .vue or vue def object)
 */
export function declareVueComponent(componentName, component) {
    Vue.component(componentName, component)
    vuejsComponents[componentName] = component;
}

/**
 * Register a vue component in vue
 * @param componentName vue component name (html element)
 * @param component vue component (import from .vue or vue def object)
 */
export function declareVueComponentAsync(componentName, componentPromise) {
    console.error('declareVueComponentAsync is broken, please use declareVueComponent instead ::',componentName)
    declareVueComponent(componentName, () => componentPromise)
}

/**
 * Register a vue component in vue
 * @param componentName vue component name (html element)
 * @param component vue component (import from .vue or vue def object)
 * @deprecated use declareVueComponents instead
 */
export function declareComponents(name, module) {
    declareVueComponents(name, module)
}

/**
 * Register a vue component in vue
 * @param componentName vue component name (html element)
 * @param component vue component (import from .vue or vue def object)
 */
export function declareVueComponents(name, module) {
    if (module.default) {
        declareVueComponent(name, module.default)
        return
    }

    Object.entries(module).forEach(([name, module]) => declareVueComponents(name, module))
}

export function declareDirectives(name, module) {
    if (module.default) {
        declareDirective(name, module.default)
        return
    }

    Object.entries(module).forEach(([name, module]) => declareDirectives(name, module))
}

export function declareDirective(directiveName, directive) {
    Vue.directive(directiveName, directive)
}




/**
 * Register a vue component and its angular wrapper stuff
 * @param type vodalysform type
 * @param name un nom genre unNomCommeCa
 * @param componentPromise une promesse de component vue `import('componentpath')`
 * @deprecated registerVueComponentAndAngularBindingsAsync is broken, use declareVconsoleComponent insted
 */
export function registerVueComponentAndAngularBindingsAsync(type, name, componentPromise, weight) {
    console.error('registerVueComponentAndAngularBindingsAsync is broken, please use registerVueComponentAndAngularBindings instead ::',name)
    registerVueComponentAndAngularBindings(type, name, () => componentPromise, weight)
}

/**
 * Register a vue component and its angular wrapper stuff
 * @param type vodalysform type
 * @param name un nom genre unNomCommeCa
 * @param component un component vuejs
 * @deprecated use registerVconsoleComponent instead
 */
export function registerVueComponentAndAngularBindings(type, name, component, weight = 30) {

    const ngModuleName = `${name}NgModule`
    const ngComponentName = `${name}NgComponent`

    const ngComponentNameKebab = camelToKebab(ngComponentName)

    const module = angular.module(ngModuleName, [])
    registerAngularModule(module.name)

    module.component(ngComponentName, {
        controller: [function () {
            this.vueComponents = {
                [name]: component
            }
        }],
        bindings: {
            component: '<',
            handler: '<'
        },
        template: `
                <v-wrapper name="${ngComponentName}" component="$ctrl.component" handler="$ctrl.handler" vue-components="$ctrl.vueComponents">
                        <${camelToKebab(name)} :component="component" :handler="handler"></${camelToKebab(name)}>
                </v-wraper>`,
    })

    // registerVueComponent(type, ngComponentNameKebab, component)

    module.run(['vodalys_form_service', function (vodalys_form_service) {
        vodalys_form_service.register({
            weight: weight,
            valid: vodalys_form_service.typeValidator(type),
            directive: ngComponentNameKebab
        })
    }])
}

export function declareFilter(name, callback) {
    Vue.filter(name, callback);
}

export function declareVConsoleModule(moduleName) {
    const module = angular.module(moduleName, [])
    registerAngularModule(module.name)

    return module
}
export function declareVrunModule(moduleName, instanceFunction = null) {
    const module = angular.module(moduleName, [])
    registerAngularModule(module.name)
    module.service(`${moduleName}.factory`, instanceFunction ?? function () {
        return function factory(id) {
            var instance = {
                'id': id,
            }
            return instance;
        }
    })

    return module
}

export async function autoNgVueWraperLasy(ngModule, ngComponentName, vueName, vueComponentPromise) {
    console.error('autoNgVueWraperLasy is broken, please use autoNgVueWraper instead ::',ngComponentName, vueName)
    autoNgVueWraper(ngModule, ngComponentName, vueName, () => vueComponentPromise) 
}

export function autoNgVueWraper(ngModule, ngComponentName, vueName, vueComponent) {

    if (process.env.NODE_ENV === 'development') {
        console.warn('DEVLOG : please use vrunAutoNgVueWraper instead of autoNgVueWraper')
    }

    vrunAutoNgVueWraper(ngModule, ngComponentName, vueName, vueComponent)
}


/**
 * 
 * @param {*} ngModule 
 * @param {*} ngComponentName 
 * @param {*} vueName 
 * @param {*} vueComponent 
 */
export function vrunAutoNgVueWraper(ngModule, ngComponentName, vueName, vueComponent) {

    ngModule.component(ngComponentName, {
        controller: ['$scope', 'vRunScope', function ($scope, vRunScope) {
            
            this.instance = vRunScope.bindScope($scope, this.component['instance_id']);

            this.vueComponents = {
                [vueName]: vueComponent
            }
        }],
        bindings: {
            component: '=',
            handler: '='
        },
        template: `
                <v-wrapper name="${ngComponentName}" component="$ctrl.component" instance="$ctrl.instance" vue-components="$ctrl.vueComponents">
                        <${camelToKebab(vueName)} :component="component" :instance="instance" :handler="handler"></${camelToKebab(vueName)}>
                </v-wraper>`,
    })
}



export function vconsoleAutoNgVueWraper(ngModule, ngComponentName, vueName, vueComponent) {

    ngModule.component(ngComponentName, {
        controller: [function () {
            this.vueComponents = {
                [vueName]: vueComponent
            }
        }],
        bindings: {
            component: '=',
            handler: '='
        },
        template: `
                <v-wrapper name="${ngComponentName}" component="$ctrl.component" handler="$ctrl.handler" vue-components="$ctrl.vueComponents">
                        <${camelToKebab(vueName)} :component="component" :handler="handler"></${camelToKebab(vueName)}>
                </v-wraper>`,
    })
}